/**
 * Clés de cache, centralisées.
 *
 * Écrites ici plutôt qu'en ligne dans chaque hook : invalider après une
 * écriture suppose de désigner exactement la même clé, et deux tableaux
 * écrits à deux endroits finissent toujours par diverger d'un caractère.
 *
 * Le portail est plus petit que l'outil interne, mais la règle vaut d'autant
 * plus : tout y tourne autour du même CRA, lu depuis trois écrans.
 */
export const queryKeys = {
  /** Le consultant connecté et ses missions. L'identité vient du jeton. */
  portal: {
    all: ['portal'] as const,
    profile: () => [...queryKeys.portal.all, 'profile'] as const,
    missions: () => [...queryKeys.portal.all, 'missions'] as const,
  },

  timesheets: {
    all: ['timesheets'] as const,
    lists: () => [...queryKeys.timesheets.all, 'list'] as const,
    list: (filters: object) => [...queryKeys.timesheets.lists(), filters] as const,
    details: () => [...queryKeys.timesheets.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.timesheets.details(), id] as const,
    options: () => [...queryKeys.timesheets.all, 'options'] as const,
    /**
     * Questionnaire de satisfaction, par CRA et par étape.
     *
     * Clé distincte du CRA : le questionnaire dépend de l'acteur et du moment,
     * et il est administrable — le recharger avec la fiche serait inutile.
     */
    satisfaction: (id: string, stage: string) =>
      [...queryKeys.timesheets.all, 'satisfaction', id, stage] as const,
  },

  /**
   * Boîte de réception.
   *
   * Une seule clé de liste, paginée : le compteur de non lus voyage dans la
   * même réponse, donc l'invalider après une lecture met à jour la pastille de
   * navigation du même coup.
   */
  messages: {
    all: ['messages'] as const,
    list: (page: number) => [...queryKeys.messages.all, 'list', page] as const,
  },

  leaves: {
    all: ['leaves'] as const,
    lists: () => [...queryKeys.leaves.all, 'list'] as const,
    list: (filters: object) => [...queryKeys.leaves.lists(), filters] as const,
    /** Solde d'une mission — calculé par le serveur, jamais stocké. */
    balance: (missionId: string) => [...queryKeys.leaves.all, 'balance', missionId] as const,
  },
} as const;
